import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import * as actions from '../../actions';

const styles = {
	container: {
		display: 'flex',
		flexWrap: 'wrap'
	},
	textField: {
		marginLeft: '10px',
		marginRight: '10px',
		width: 300
	},
	button: {
		marginTop: '20px'
	}
};

class RegisterForm extends Component {
	constructor(props) {
		super(props);

		this.history = this.props.history;
	}

	state = {
		canSubmit: false,
		email: '',
		password: ''
	};

	disableButton = () => {
		this.setState({ canSubmit: false });
	};

	enableButton = () => {
		this.setState({ canSubmit: true });
	};

	handleChange = name => event => {
		this.setState(
			{
				[name]: event.target.value
			},
			() => {
				if (
					this.state.email &&
					this.state.password &&
					this.state.name &&
					this.state.key
				) {
					return this.enableButton();
				}
				return this.disableButton();
			}
		);
	};

	submitRegisterUserForm = () => {
		const { email, password, name, key } = this.state;
		const user = {
			email,
			password,
			name,
			key
		};
		this.props.registerUser(user, this.history);
	};

	render() {
		return (
			<div>
				<form className={styles.container} noValidate autoComplete="off">
					<div>
						<TextField
							InputProps={{ disableUnderline: true }}
							id="email"
							label="Email"
							color="#c655d6"
							type="email"
							style={styles.textField}
							onChange={this.handleChange('email')}
						/>
					</div>
					<div>
						<TextField
							InputProps={{ disableUnderline: true }}
							id="password"
							label="Password"
							style={styles.textField}
							type="password"
							onChange={this.handleChange('password')}
						/>
					</div>
					<div>
						<TextField
							InputProps={{ disableUnderline: true }}
							id="name"
							label="Business Name"
							color="#c655d6"
							style={styles.textField}
							onChange={this.handleChange('name')}
						/>
					</div>
					<div>
						<TextField
							InputProps={{ disableUnderline: true }}
							id="key"
							label="Chekkit Key"
							type="password"
							color="#c655d6"
							style={styles.textField}
							onChange={this.handleChange('key')}
						/>
					</div>
					<div>
						<Button
							disabled={!this.state.canSubmit}
							size="large"
							variant="contained"
							color="primary"
							style={styles.button}
							onClick={this.submitRegisterUserForm}
						>
							Complete Registration
						</Button>
					</div>
				</form>
			</div>
		);
	}
}

function mapStateToProps(state) {
	return {
		auth: state.auth,
		error: state.error
	};
}

export default connect(
	mapStateToProps,
	actions
)(withRouter(RegisterForm));



// WEBPACK FOOTER //
// ./src/components/register/RegisterForm.js